import type { ReactNode } from 'react';
import * as Styled from './ImageLink.styled';

interface ImageLinkProps {
  children: ReactNode;
  href: string;
  isRound?: boolean;
  label: string;
  width?: number;
}

export const ImageLink = ({
  children,
  href,
  isRound = false,
  label,
  width,
}: ImageLinkProps) => (
  <Styled.Link aria-label={label} href={href} $isRound={isRound} $width={width}>
    {children}
  </Styled.Link>
);
